module.exports = __webpack_public_path__ + "img/calendar.0ad5806d.svg";